// These are the rare bits that need to be set up or imported globally
// in the strictly-modern js context. Nothing specific to one
// entrypoint, app, or feature should be included here. Instead, this
// sets up the global InstUI Theme, imports the fonts we need, and
// that sort of thing.

import 'setup/load_fonts';
import InstUISetup from 'setup/instui';
import SentrySetup from '../mc-sdk/sentry'

InstUISetup();
SentrySetup();
